import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface DismissibleErrorAlertProps {
  message: string;
  onDismiss: () => void;
}

const DismissibleErrorAlert: React.FC<DismissibleErrorAlertProps> = ({ message, onDismiss }) => {
  const { t } = useTranslation();

  return (
    <Alert variant="destructive" className="mb-6 flex items-start gap-4">
      <AlertDescription className="revy-cjk flex-1 leading-[1.6]">{message}</AlertDescription>
      <Button
        variant="ghost"
        size="icon-sm"
        // -my-1: the 32px button would otherwise set the row height and leave a
        // 22px line of text sitting above centre.
        className="-my-1"
        aria-label={t('common.close', '閉じる')}
        onClick={onDismiss}
      >
        <X strokeWidth={1.9} />
      </Button>
    </Alert>
  );
};

export default DismissibleErrorAlert;
